import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({ providedIn: 'root' })
export class DialogCustomService {

    constructor(private dialogService: DialogService) { }

    open(component: any, parameters: any = {}): DynamicDialogRef {

        // Defaults globales
        const defaultParams = {
            closable: true,
            closeButtonProps: {
                tooltip: 'Cerrar ventana',
                tooltipPosition: 'top'
            },
            contentStyle: {}
        };

        // Merge seguro
        parameters = {
            ...defaultParams,
            ...parameters,
            closeButtonProps: {
                ...defaultParams.closeButtonProps,
                ...(parameters.closeButtonProps ?? {})
            },
            contentStyle: {
                ...defaultParams.contentStyle,
                ...(parameters.contentStyle ?? {})
            }
        };

        // Ajustes de altura
        if (!parameters.contentStyle['max-height']) {
            parameters.contentStyle['max-height'] = (window.innerHeight - 30) + 'px';
        }

        if (!parameters.contentStyle['overflow']) {
            parameters.contentStyle['overflow'] = 'auto';
        }

        setTimeout(() => {
            const elements = document.getElementsByClassName('p-dialog-header-icon');

            for (let i = 0; i < elements.length; i++) {
                const el = elements[i] as HTMLElement;
                el.setAttribute('title', 'Cerrar ventana');
            }
        }, 1000);

        return this.dialogService.open(component, parameters);
    }
}
